export const hu = {
  // Navigation
  navigation: {
    whyChooseUs: "Miért Dubai",
    marketGrowth: "Növekedés",
    dubaiVsBudapest: "Dubai vs Budapest",
    megaprojects: "Projektek",
    ourEvent: "Rendezvényünk",
    startInvestment: "Kezdjük",
  },

  // Language Selector
  languageSelector: {
    title: "Nyelv",
  },

  // Banner
  banner: {
    title: "Dubai",
    subtitle: "A Világ Vezető Ingatlan Befektetési Központja",
    description:
      "Prémium ingatlanbefektetési lehetőségek nulla adóval, világszínvonalú biztonsággal és kivételes életstílus előnyökkel.",
    cta: "Kapcsolat",
  },

  // Stats
  stats: {
    personalIncomeTax: "Személyi Jövedelemadó",
    sunnyDays: "Napos Nap",
    safestCity: "Legbiztonságosabb Város",
  },

  // Stats Section
  statsSection: {
    gdpGrowth: "GDP Növekedés 2025",
    annualPassengers: "Éves Utasszám DXB",
    nonOilGdp: "Nem-olaj GDP Részarány",
    countryRanking: "Ország Ranglista",
  },

  // Investment Drivers
  investmentDrivers: {
    title: "Befektetési Hajtóerők",
    description:
      "A top 5 tényező, amely Dubai-t a világ vezető ingatlanbefektetési célpontjává tette 2010-2025 között.",
    items: [
      {
        title: "Biztonság & Stabilitás",
        description:
          "Top 5 legbiztonságosabb város világszinten, alacsony bűnözési index és stabil politikai környezet.",
      },
      {
        title: "Nulla Adó Politika",
        description:
          "0% személyi jövedelemadó, tőkenyereségadó, öröklési adó és vagyonadó - maximális profit megtartása.",
      },
      {
        title: "Politikai Neutralitás",
        description:
          "Szigorú geopolitikai semlegesség, szabad tőkemozgás és ingatlanvásárlás minden nemzetiség számára.",
      },
      {
        title: "Migráció & Népesség",
        description:
          "200,000+ orosz ajkú expat, 4,000+ milliomos és Golden Visa program 10 éves tartózkodással.",
      },
    ],
  },

  // WhoWeAre
  whoWeAre: {
    subtitle: "Rólunk",
    title: "Fenntartható kriptovaluta bányászat zöld energiával",
    description:
      "A Realiste célja, hogy új szintre emelje a dubai ingatlanbefektetést, miközben fenntartható és átlátható módon biztosít valódi értéket partnerei számára. Saját dubai ingatlanportfólióval és prémium környékekre épülő infrastruktúrával biztosítjuk a magas hozamot, miközben stabil befektetési lehetőséget kínálunk.",
    description2:
      "Folyamatosan felügyelt konténeres gépekkel, valós adatokon alapuló ROI kalkulációkkal és piacvezető hardverekkel biztosítjuk az átlátható, érthető és kiszámítható befektetési lehetőséget.",
  },

  // OurMission
  ourMission: {
    subtitle: "Küldetésünk",
    title: "Maximális hatékonyság és folyamatos működés",
    description:
      "A Realiste célja, hogy fenntartható módon, dubai prémium ingatlanokkal üzemeltesse befektetési portfólióját. Jelenleg három saját dubai ingatlanunk működik Downtown Dubai-ban, Dubai Marina-ban és Palm Jumeirah-n. A befektetést prémium környékekre helyezett ingatlanokkal végezzük, ami luxus szolgáltatásokkal, infrastruktúra szempontjából teljesen optimalizált. A befektetésre szánt tőke így prémium ingatlanokba kerül, maximálisra növelve a hozamot.",
    description2:
      "A gépek működése 24/7 biztosított. A hűtés, energiaellátás, és hardveres optimalizáció biztosítja, hogy a lehető legmagasabb hash rate-et érjük el, stabil költségszinten. Egy konténerben akár 100 gép is működik egyszerre. A karbantartást, felügyeletet és riportolást saját csapatunk végzi.",
  },

  // WhyChooseUs
  whyChooseUs: {
    subtitle: "Miért válassz minket",
    title: "Miért Válassza Dubai-t?",
    description:
      "Dubai egyedülálló előnyöket kínál az ingatlanbefektetők számára. Fedezze fel, mi teszi ezt a várost a világ legkiemelkedőbb befektetési célpontjává.",
    items: [
      {
        title: "Kimagasló Befektetési Hozam",
        description:
          "Dubai ingatlanpiacán átlagosan 8-12% éves hozam várható, stabil értéknövekedéssel.",
      },
      {
        title: "Nemzetközi Üzleti Központ",
        description:
          "A Közel-Kelet pénzügyi és kereskedelmi központja, kiváló üzleti lehetőségekkel.",
      },
      {
        title: "Luxus Életstílus",
        description:
          "Világszínvonalú infrastruktúra, shopping központok és szórakozási lehetőségek.",
      },
      {
        title: "Kulturális Sokszínűség",
        description:
          "200+ nemzetiség él békében Dubai-ban, nyitott és befogadó közösség.",
      },
      {
        title: "Adóoptimalizálás",
        description:
          "0% személyi jövedelemadó, 5% ÁFA, nincs tőkenyereségadó ingatlanokra.",
      },
      {
        title: "Stratégiai Helyzet",
        description:
          "Ázsia, Afrika és Európa találkozásánál, 4 órás repülőútra 2 milliárd embertől.",
      },
    ],
  },

  // Technology
  technology: {
    subtitle: "Technológia",
    bitcoin: {
      title: "Bitcoin bányászat (BTC)",
      description:
        "A Bitcoin a világ első decentralizált digitális valutája, 2009-ben indult. Maximálisan 21 millió darab érhető el belőle, biztosítva a deflációs modellt. Mára globálisan elfogadott eszköz – intézményi befektetők, bankok és országok is aktív szereplők. Likviditása és értékállósága miatt hosszú távú megtakarítási eszközzé vált.",
    },
    aleo: {
      title: "Aleo bányászat",
      description:
        "Az Aleo egy újgenerációs blokklánc, amely Zero-Knowledge Proof technológiát használ. Privát smart contractok futtatását teszi lehetővé, teljes titkosítás mellett. A projekt Google Ventures és A16Z által támogatott, a piac szerint az egyik legnagyobb növekedési potenciállal rendelkező Layer 1 hálózat.",
    },
    infrastructure: {
      title: "Infrastruktúra",
      items: [
        "Saját napelemparkok – költségoptimalizált, független működés",
        "Konténeres géptelepítés – klimatizált, szerverközpont szintű hatékonyság",
        "Antminer S19 Pro és ekvivalens gépek",
        "Online monitoring, teljes átláthatóság",
      ],
    },
  },

  // Roadmap
  roadmap: {
    subtitle: "Piaci Növekedési Adatok",
    title: "Piaci Növekedési Adatok",
    items: [
      {
        year: "2010",
        title: "1.9M",
        points: ["+3%", "Infrastruktúra fejlesztés"],
      },
      {
        year: "2014-15",
        title: "2.3M",
        points: ["+7%", "Arab Tavasz hatása"],
      },
      {
        year: "2018",
        title: "3.0M",
        points: ["+2%", "Olajár volatilitás"],
      },
      {
        year: "2020",
        title: "3.3M",
        points: ["-4%", "COVID-19 hatása"],
      },
      {
        year: "2022",
        title: "3.6M",
        points: ["+22%", "Orosz-ukrán háború"],
      },
      {
        year: "2024",
        title: "3.8M",
        points: ["+16%", "Folyamatos migráció"],
      },
    ],
  },

  // Roadmap Stats
  roadmapStats: {
    realEstateGrowth: "Ingatlanár növekedés 2022-2024",
    foreignInvestors: "Külföldi ingatlanbefektetők 2022",
    nonOilGdp: "Nem-olaj szektor GDP részarány",
    airportPassengers: "DXB repülőtér utasszám 2025",
  },

  // Project categories
  projectCategories: {
    megaprojectsSubtitle: "Dubai megaprojektek",
    microInvestmentsTitle: "Mikrobefektetések",
    microInvestmentsComingSoon: "Részletek hamarosan",
    microInvestmentsSubtitle: "Frakcionalizált ingatlanbefektetések",
    microInvestmentsDescription: "100.000 Forintból is tudsz ingatlant venni.",
  },

  // Megaprojects
  megaprojects: {
    subtitle: "UAE Vision 2031",
    title: "Megaprojektek",
    description:
      "UAE Vision 2031 és Dubai Economic Agenda (D33) keretében megvalósuló transformatív fejlesztések, amelyek a gazdaság megduplázását célozzák.",
    items: [
      {
        title: "Masdar City",
        status: "Építés alatt",
        location: "Abu Dhabi",
        year: "2030",
        description:
          "6 km² eco-város, megújuló energia központ, zéró-karbon fejlesztés",
        category: "Fenntartható Város",
        cost: "22 milliárd USD",
      },
      {
        title: "MBR Solar Park",
        status: "Folyamatban",
        location: "Dubai",
        year: "2030",
        description: "5,000 MW naperőmű, a világ legnagyobb ilyen projektje",
        category: "Megújuló Energia",
        cost: "14 milliárd USD",
      },
      {
        title: "Etihad Rail",
        status: "Utolsó fázis",
        location: "UAE",
        year: "2024",
        description:
          "900 km vasúthálózat, áruszállítás 2023-tól, személyszállítás 2024-től",
        category: "Infrastruktúra",
        cost: "11 milliárd USD",
      },
      {
        title: "Wynn Al Marjan Island",
        status: "Építés alatt",
        location: "Ras Al Khaimah",
        year: "2027",
        description: "Luxus resort, 1,542 szoba, első szárazföldi kaszinó",
        category: "Turizmus & Szórakozás",
        cost: "3.9 milliárd USD",
      },
      {
        title: "Stargate Al Data Centre",
        status: "Tervezés",
        location: "UAE",
        year: "2026",
        description: "10 négyzetmérföld AI központ, 5 GW kapacitás, 100k GPU",
        category: "Technológia",
        cost: "100+ milliárd USD",
      },
      {
        title: "The Loop",
        status: "Koncepció",
        location: "Dubai",
        year: "TBD",
        description:
          "93 km klímavezérelt gyalogos/kerékpáros folyosó, zéró kibocsátás",
        category: "Közlekedés",
        cost: "TBD",
      },
    ],
  },

  // Megaprojects Stats
  megaprojectsStats: {
    gdpTarget: "3 Billió AED",
    gdpDescription: "UAE GDP cél 2031-re (megduplázás)",
    projectsCount: "100 Projekt",
    projectsDescription: "D33 keretében Dubai gazdaság megduplázása",
    completionYear: "2033",
    completionDescription: "Dubai Economic Agenda befejezési dátum",
  },

  // Famous Residents
  famousResidents: {
    subtitle: "Világsztárok",
    title: "Híres Lakosok",
    description:
      "Világsztárok és befolyásos személyiségek, akik Dubai-t választották otthonuknak vagy befektetési célpontnak.",
    items: [
      {
        name: "Pavel Durov",
        profession: "Telegram alapítója",
        status: "Dubai lakos",
        quote: "Dubai-ba költöztem, ahol a Telegram székhelye található.",
        country: "Oroszország",
        category: "Tech",
      },
      {
        name: "Lindsay Lohan",
        profession: "Színésznő",
        status: "Dubai lakos 2014 óta",
        quote:
          "Itt megkapom a magánéletet, békét és biztonságot, amire szükségem van.",
        country: "USA",
        category: "Szórakoztatás",
      },
      {
        name: "Shah Rukh Khan",
        profession: "Színész",
        status: "Ingatlan tulajdonos",
        quote: "Dubai a második otthonom... mindig van itt valami új.",
        country: "India",
        category: "Bollywood",
      },
      {
        name: "Roger Federer",
        profession: "Tenisz bajnok",
        status: "Ingatlan tulajdonos",
        quote: "Dubai jó helyszín, nem bánom, hogy bázisnak választottam.",
        country: "Svájc",
        category: "Sport",
      },
      {
        name: "Novak Djokovic",
        profession: "Tenisz bajnok",
        status: "Gyakori látogató",
        quote: "Dubai a bajnokok városa. Imádom itt.",
        country: "Szerbia",
        category: "Sport",
      },
      {
        name: "Will Smith",
        profession: "Színész",
        status: "Gyakori látogató",
        quote: "Dubai úgy álmodik, mint én – illik a lelkemhez.",
        country: "USA",
        category: "Hollywood",
      },
      {
        name: "Cristiano Ronaldo",
        profession: "Labdarúgó",
        status: "Gyakori látogató",
        quote: "Szeretem Dubai-t, az embereket és a kultúrát.",
        country: "Portugália",
        category: "Sport",
      },
      {
        name: "Giorgio Armani",
        profession: "Divattervező",
        status: "Befektető",
        quote: "Semmi sem hasonlítható Dubai csodájához.",
        country: "Olaszország",
        category: "Divat",
      },
      {
        name: "Gordon Ramsay",
        profession: "Séf",
        status: "Gyakori látogató",
        quote: "Dubai gasztronómiai színtere világszínvonalú.",
        country: "UK",
        category: "Gasztronómia",
      },
      {
        name: "CZ (Changpeng Zhao)",
        profession: "Binance CEO",
        status: "Dubai lakos",
        quote: "Dubai a kriptovaluták élvonalában áll.",
        country: "Kína",
        category: "Krypto",
      },
    ],
  },

  // Famous Residents Stats
  famousResidentsStats: {
    knownPersons: "Ismert személy él Dubai-ban",
    permanentResidents: "Állandó híresség lakos",
    nationalities: "Nemzetiség képviselve",
    expatRatio: "Expat lakosság aránya",
  },

  // Dubai vs Budapest
  dubaiVsBudapest: {
    subtitle: "Összehasonlítás",
    title: "Dubai vs Budapest",
    description:
      "Összehasonlítás a két város befektetési lehetőségei és életminősége között",
    categories: {
      title: "Kategória",
      realEstate: "Ingatlanárak",
      investmentReturn: "Befektetési hozam",
      taxation: "Adózás",
      qualityOfLife: "Életminőség",
      transportation: "Közlekedés",
      futurePotential: "Jövőbeli potenciál",
    },
    dubai: {
      realEstate: {
        value: "€4,500-15,000/m²",
        description: "Luxus környékek, adómentes tulajdonlás",
      },
      investmentReturn: {
        value: "6-10% évente",
        description: "Expo 2030, World Cup 2034 hatása",
      },
      taxation: {
        value: "0% személyi jövedelemadó",
        description: "Nincs ingatlanadó, örökösödési adó",
      },
      qualityOfLife: {
        value: "Magas szintű",
        description: "300+ napsütéses nap, biztonság",
      },
      transportation: {
        value: "Globális hub",
        description: "3 óra alatt Ázsia, Afrika, Európa",
      },
      futurePotential: {
        value: "Exponenciális",
        description: "Mesterséges intelligencia, űripar",
      },
    },
    budapest: {
      realEstate: {
        value: "€2,000-6,000/m²",
        description: "Belváros és Buda hegyek környéke",
      },
      investmentReturn: {
        value: "4-7% évente",
        description: "Stabil európai piac, EU tagság",
      },
      taxation: {
        value: "15-35% SZJA",
        description: "Ingatlanadó, öröklési díj",
      },
      qualityOfLife: {
        value: "Jó minőségű",
        description: "Európai kultúra, termálfürdők",
      },
      transportation: {
        value: "Európai központ",
        description: "Közvetlen járatok EU-ba",
      },
      futurePotential: {
        value: "Stabil növekedés",
        description: "Technológiai fejlesztések",
      },
    },
    summary: {
      dubai: {
        title: "Dubai előnyei",
        advantages: [
          "Adómentes környezet",
          "Magasabb hozamok",
          "Jövőbeli megaprojektek",
          "Globális kapcsolódás",
        ],
      },
      budapest: {
        title: "Budapest előnyei",
        advantages: [
          "Alacsonyabb belépési küszöb",
          "EU jogbiztonság",
          "Kulturális közelség",
          "Stabil piac",
        ],
      },
    },
  },

  // Contact
  contact: {
    subtitle: "Kezdje El Dubai Befektetését",
    title: "Kezdje El Dubai Befektetését",
    description:
      "Szakértő csapatunk segít megtalálni a tökéletes befektetési lehetőséget Dubai dinamikus ingatlanpiacán. Vegye fel velünk a kapcsolatot még ma!",
    email: {
      title: "Email Kapcsolat",
      description: "Írjon nekünk részletes kérdéseivel",
      address: "hello@dubaiingatlan.ai",
    },
    phone: {
      title: "Telefonos Konzultáció",
      description: "Beszéljünk személyesen a lehetőségekről",
      number: "+36 30 655 6554",
    },
    booking: {
      title: "Online konzultáció",
      description: "Kérjen 30 perces online időpontot a szabad idősávokból",
      action: "Időpont kérése",
      close: "Foglaló bezárása",
      loading: "Szabad időpontok betöltése...",
      note: "Válasszon időpontot. A kérés e-mailben érkezik meg hozzánk, az időpont a visszaigazolás után végleges.",
      slot: "Szabad időpontok (budapesti idő)",
      choose: "Válasszon időpontot",
      name: "Név",
      email: "E-mail-cím",
      phone: "Telefonszám",
      request: "Időpontkérés küldése",
      sending: "Küldés...",
      sent: "Az időpontkérését elküldtük. A találkozó a visszaigazolás után végleges.",
      taken: "Ez az időpont már nem szabad. Válasszon másikat.",
      error: "A kérés most nem küldhető el. Kérjük, próbálja újra később.",
    },
    form: {
      name: "Add meg a neved",
      email: "Add meg az email címed",
      message: "Add meg az üzeneted",
      submit: "Üzenet küldése",
    },
  },

  // Event
  event: {
    title: "Dubai Ingatlan befektetések és minden ami mögötte van",
    subtitle: "Dubai Ingatlanok Belsőleg: A Pénz, Mítoszok & Milliós Lépések",
    mainTitle: "Dubai Ingatlanok — Az Igazság a Hírverés Mögött",
    date: "szeptember 17. csütörtök",
    time: "16:00",
    location: "Breitling Boutique 1061 Budapest Andrássy út 14",
    description: {
      title: "Rendezvény részletei",
      text: "Vegyen részt exclusív zártkörű (ingyenes) rendezvényünkön az Al Habtoor Palace Budapest-ben. Szeptember 17-én délután. 16:00",
    },
    learn: {
      title: "Megtudhatja:",
      item1:
        "Valóban megéri-e Dubai-ban ingatlant vásárolni — és mikor nem éri meg.",
      item2: "Mire figyeljen nemzetközi befektetés előtt.",
      item3:
        "Hogyan ismerje fel a figyelmeztető jeleket és kerülje el a költséges buktatókat.",
    },
    plus: {
      title: "Ráadásul:",
      item1:
        "Objektív képet kap a teljes dubai piacról — nem csak néhány fejlesztői ajánlatról.",
      item2:
        "Fedezze fel a Realiste.ai-t, a világ első mesterséges intelligenciáját, amely végigvezeti Önt a Dubai-ban történő ingatlanvásárlás minden lépésén.",
      item3: "Tegyen fel kérdéseket és kapjon valós, adatalapú válaszokat.",
    },
    guest: {
      title: "Alex Galt-ról:",
      description:
        "Alex Galt a Realiste.ai és Titleman.ai alapítója, csúcstechnológiás mesterséges intelligenciával működő platformok, amelyek segítik a felhasználókat az ingatlanbefektetésben és ingatlanszerzésben. 300 millió dolláros értékesítési teljesítménnyel 600 ingatlanügyleten keresztül, Alex gyakorlati tapasztalatot és technológiai innovációt egyaránt hoz az ingatlanvilágba.",
    },
    whyDifferent: {
      title: "🌟 Miért Más Ez A Rendezvény",
      description:
        'Ez nem egy újabb "eladási" szeminárium vagy fejlesztői bemutató — ez egy adatvezérelt, pártatlan mélyelemzés a valódi dubai ingatlanpiacról. Megtudhatja, hová megy az okos pénz, milyen hibákat követnek el még a tapasztalt befektetők is, és hogyan találjon olyan üzleteket, amelyek 3–5 év alatt megduplázhatják tőkéjét.\n\nNem ajánlatokat fog hallani — hanem mesterséges intelligencia elemzéseket, élő piaci hőtérképeket és valós esettanulmányokat olyan befektetőktől, akik technológia segítségével építettek fel 7 számjegyű portfóliókat találgatás helyett.\n\nÉs találkozhat Alex Galt-tal, a Realiste.ai és Titleman.ai alapítójával — platformok, amelyek mögött több mint 300 millió dollár elemzett tranzakció áll — aki olyan bennfentes ismereteket oszt meg, amelyeket más rendezvényeken nem talál.',
    },
    whyInvestors: {
      title: "💰 Miért Használják A Befektetők A Realiste.ai-t",
      items: [
        {
          title: "Rejtett Lehetőségek Azonnali Megtalálása",
          description:
            "A Realiste mesterséges intelligenciája az egész dubai ingatlanpiacot átvizsgálja — nem csak a fejlesztői listákat — hogy azonosítsa az alulértékelt ingatlanokat és a magas megtérülésű befektetési lehetőségeket. Olyan mutatók alapján rangsorol projekteket, mint a várható felértékelődés, bérleti hozam és ár-piaci rés, segítve a befektetőket olyan ügyletek megtalálásában, amelyek 3-5 év alatt megduplázódhatnak.",
        },
        {
          title: "Objektív, Adatvezérelt Döntések",
          description:
            "Ahelyett, hogy az ügynökök véleményére vagy marketing ígéretekre támaszkodnának, a befektetők valós idejű piaci adatokat kapnak több száz ellenőrzött forrásból (DLD, Bayut, Property Finder stb.). A mesterséges intelligencia a város minden projektjét összehasonlítja, megmutatva, hol vannak a valódi profitok — objektíven és azonnal.",
        },
        {
          title: "Portfólió Optimalizálás & Előrejelzések",
          description:
            "A befektetők láthatják, hogy minden ingatlan hogyan teljesít az idő múlásával — várható megtérülés, bérleti díj növekedés és újraértékesítési potenciál. Ez lehetővé teszi számukra kiegyensúlyozott portfóliók építését: pénzforgalmi egységek, felértékelődési fogadások és stabil hosszú távú befektetések, mind adatokkal támogatva a találgatás helyett.",
        },
        {
          title: "Nincs Ügynöki Nyomás, Nincs Rejtett Elfogultság",
          description:
            "A Realiste független tanácsadóként működik, nem korlátozott készletű brókerként. A teljes piacot mutatja, teljes átláthatósággal — beleértve azokat az egységeket is, amelyeket a brókerek nem erőltetnek, mert kisebb jutalékot fizetnek.",
        },
        {
          title: "Sebesség & Végrehajtás",
          description:
            "A befektetők gyorsabban foglalhatnak, ellenőrizhetnek és zárhatnak le üzleteket — gyakran 24–72 órán belül — a Realiste integrált hálózatán keresztül, amely fejlesztőket, bankokat és jogi partnereket foglal magába. Minden, az átvilágítástól a szerződésekig, digitálisan támogatott.",
        },
        {
          title: 'Hozzáférés Exkluzív "AI Választásokhoz"',
          description:
            "A rendszer minden héten kiemeli a befektetési szempontból legjobb 1%-ot — azokat, amelyek a legerősebb alapokkal és legalacsonyabb kockázattal rendelkeznek. Sok befektető ezeket a betekintéseket használja, hogy cselekedjen, mielőtt a projektek nyilvánosan trendivé válnának.",
        },
        {
          title: "Globális Terjeszkedés & Diverzifikáció",
          description:
            "Dubai-n túl a Realiste világszerte 132+ városban terjeszkedik, egyetlen platformot biztosítva a befektetőknek a nemzetközi ingatlanok követésére, összehasonlítására és vásárlására konzisztens elemzésekkel és jogi támogatással.",
        },
      ],
    },
    registration: {
      title: "Regisztráció",
      note: "A részvétel ingyenes, de regisztrációhoz kötött.",
      form: {
        name: "Név",
        namePlaceholder: "Adja meg a nevét",
        email: "Email cím",
        emailPlaceholder: "Adja meg az email címét",
        phone: "Telefonszám",
        phonePlaceholder: "Adja meg a telefonszámát",
        consultationMode: "Konzultáció módja",
        consultationModePlaceholder: "Válasszon konzultációs módot",
        consultationModeInPerson: "Személyes",
        consultationModeOnline: "On-line",
        message: "Üzenet (opcionális)",
        messagePlaceholder: "Írjon üzenetet...",
        submit: "Regisztráció",
        submitting: "Regisztrálás...",
      },
      successMessage:
        "Sikeres regisztráció! Hamarosan felvesszük Önnel a kapcsolatot.",
      errorMessage: "Hiba történt a regisztráció során. Kérjük, próbálja újra.",
    },
  },

  thankYou: {
    title: "Köszönjük a regisztrációt!",
    description:
      "Sikeresen megkaptuk az űrlapot. Hamarosan felvesszük Önnel a kapcsolatot.",
    button: "Vissza a főoldalra",
  },

  // Footer
  footer: {
    description:
      "A Realiste fenntartható ingatlanbefektetést végez prémium környékekkel és saját dubai ingatlanportfólióval. Átlátható, kiszámítható befektetési lehetőséget kínálunk valós infrastruktúrával és piacvezető technológiával.",
    navigation: "Navigáció",
    copyright: "Copyright © 2025. Minden jog fenntartva Realiste",
    terms: "Feltételek és szolgáltatások",
    privacy: "Adatvédelmi irányelvek",
  },
};
